readBlockString